import React from 'react';
import { withRouter } from "react-router-dom";
import Box from '@material-ui/core/Box';
import ScaleButton from './ScaledButton';

function BackButton({ url, history, buttonProps, ...props }) {

  const onClick = () => {
    history.push(url);
  };

  return (
    <Box {...props}>
      <ScaleButton variant="contained" color="secondary" onClick={onClick} {...buttonProps}>Back</ScaleButton>
    </Box>
    );
}

export default withRouter(BackButton);